import React, { useState } from "react";
import { Link as LinkIcon, Copy, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export function SheetLinks({ label, items, testidPrefix }) {
  const list = Array.isArray(items) ? items.filter((s) => s?.label || s?.url) : [];
  const [copiedIdx, setCopiedIdx] = useState(null);
  if (list.length === 0) return null;
  const withProtocol = (u) => {
    const s = String(u || "").trim();
    if (!s) return "#";
    return /^https?:\/\//i.test(s) ? s : `https://${s}`;
  };
  const doCopy = async (i, url) => {
    const full = withProtocol(url);
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(full);
      } else {
        const ta = document.createElement("textarea");
        ta.value = full;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopiedIdx(i);
      toast.success("Link copied");
      setTimeout(() => setCopiedIdx((v) => (v === i ? null : v)), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };
  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1.5" data-testid={`${testidPrefix}-list`}>
      <span className="text-[10px] uppercase tracking-wider text-slate-400">{label}</span>
      {list.map((s, i) => (
        <span key={i} className="inline-flex items-center gap-1">
          <a
            href={withProtocol(s.url)}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-xs sm:text-sm text-blue-600 hover:text-blue-800 hover:underline break-all"
            data-testid={`${testidPrefix}-link-${i}`}
          >
            <LinkIcon size={12} /> {s.label || s.url}
          </a>
          <button
            type="button"
            onClick={() => doCopy(i, s.url)}
            className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded shrink-0"
            title="Copy link"
            data-testid={`${testidPrefix}-copy-${i}`}
          >
            {copiedIdx === i ? <Check size={12} weight="bold" className="text-emerald-600" /> : <Copy size={12} />}
          </button>
        </span>
      ))}
    </div>
  );
}
